import React from 'react'
import { myqr } from "../../constants/Images"
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";

export default function AuctionPayment() {
    const [teampack, setteampack] = useState(2)
    const aucmoredetail = useSelector((state) => state.actmoredata);

    return (
        <div className='aucPaymentContainer'>

            <div className="aucTeamDetail">
                <div className="col-md-12">
                    <div style={{ textAlign: 'left' }}>Pricing is according to number of teams</div>
                    <select
                        className="form-control"
                        type="text"
                        value={teampack}
                        onChange={(e) => setteampack(e.target.value)}
                    >
                        <option value={0}>For 3 to 4 Teams</option>
                        <option value={1}>For 5 to 8 Teams</option>
                        <option value={2}>For 8 to 12 Teams</option>
                        <option value={3}>For 13 to 16 Teams</option>
                        <option value={4}>For 17 to 22 Teams</option>
                    </select>
                </div>
                <div className="aucTeamPack">
                    <div className='PayDetail1'>Activate your auction for {teampack==0?'3':teampack==1?'5':teampack==2?'8':teampack==3?'13':'19'} to {teampack==0?'4':teampack==1?'7':teampack==2?'12':teampack==3?'18':'30'} teams</div>
                    <div className='paydetail2'>Rs {teampack==0?'3000':teampack==1?'4000':teampack==2?'5000':teampack==3?'6000':'7000'}/-</div>
                </div>
            </div>
            <div className="freeplans">
                <div className="freeheader">Payment Method</div>
                <div className="extcontent">

                    <div className='bankhd'>Bank Account</div>
                    <div>Account Name: Harsh Technology</div>
                    <div>Account Number: 02211100004426</div>
                    <div>Bank : Punjab and Sind Bank</div>
                    <div>Branch : Chopasani Road, Jodhpur</div>
                    <div>IFSC Code : PSIB0000221</div>
                </div>
                <div style={{ marginTop: '1rem' }} className="extcontent">
                    <div className="bankdetflex">
                        <div>
                            <div>UPI-GPay, PhonePe, PayTM</div>
                            <div className='bankhd'><b>harshtech@psbank</b></div>
                            {/* <div> <b>9351171577 </b>(Madho singh)</div>
                                    <div>UPI : mscosian@okicici</div> */}
                        </div>
                        <div className="qrdiv">
                            <div>
                                <img src={myqr} alt="qrcode" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='sharemsg'>Share receipt on Whatsapp -<b style={{ color: 'yellow' }}> 8386011123</b></div>
                <div></div>
            </div>
        </div>
    )
}
